import React from 'react';
import { Box, Typography, Button, IconButton } from '@mui/material';
import { MdClose } from 'react-icons/md';
import { FiPhoneCall } from 'react-icons/fi';

const ContactPopup = ({ open, onClose, t,phoneNumberSupport }) => {
    if (!open) return null;
    return (
        <Box
            sx={{
                position: 'fixed',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                backgroundColor: '#fff',
                borderRadius: '8px',
                boxShadow: 3,
                width: '400px',
                padding: '24px',
                zIndex: 9999,
            }}
        >
            {/* Header */}
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    borderBottom: '2px solid #12538B',
                    paddingBottom: '12px',
                    marginBottom: '16px',
                }}
            >
                <Typography sx={{ fontSize: '18px', fontWeight: 600, color: '#12538B' }}>
                    {t.contactPopup.header}
                </Typography>
                <IconButton onClick={onClose}>
                    <MdClose size={24} color="#12538B" />
                </IconButton>
            </Box>
            {/* Body */}
            <Typography sx={{ fontSize: '14px', color: '#555', marginBottom: '16px', textAlign: "left" }}>
                {t.contactPopup.bodyMessage}                </Typography>
            <Typography sx={{ fontSize: '14px', color: '#555', marginBottom: '24px', textAlign: "left" }}>
                {t.contactPopup.questionsMessage}            </Typography>
            {/* Contact Information */}
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    marginBottom: '16px',
                    gap: '12px',
                }}
            >
                <FiPhoneCall size={20} color="#12538B" />
                <Typography sx={{ fontSize: '16px', fontWeight: 500, color: '#12538B' }}>
                   {phoneNumberSupport}
                </Typography>
            </Box>

            {/* Done Button */}
            <Button
                variant="contained"
                fullWidth
                sx={{
                    backgroundColor: '#0D4975',
                    fontSize: '14px',
                    fontWeight: 500,
                    textTransform: 'none',
                }}
                onClick={onClose}
            >
               {t.contactPopup.doneButton}
            </Button>
        </Box>
    );
};

export default ContactPopup;
